<template>
    <DataPostViewPage :data="data" :modalOpen="modalOpen" />
    <div class="modal_container" v-show="modalCheck" @click.stop>
        <div class="modal_wrapper modal-1" @click.stop="">
            <div class="modal_header">
                <p>안내</p>
                <button class="modal_close" @click="modalOpen">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <form class="modal_box" @submit.prevent="() => checkPwd(modalNumber, this.$refs.pwd.value)">
                    <div class="title_row">
                        <p class="title">비밀번호를 입력해주세요.</p>
                    </div>
                    <div class="input_group">
                        <input type="password" placeholder="비밀번호를 입력해주세요." ref="pwd" />
                    </div>
                    <div class="button_group">
                        <button @click="modalOpen" type="button" class="cancle">취소</button>
                        <button type="submit">확인</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { checkDownloadDetail, getDownloadDetail } from '@/api';
import { getDownloadPassword, removeDownloadPassword, setDownloadPassword } from '@/utils/downloadPassword';
import DataPostViewPage from '../../common/DataPostViewPage.vue';

export default {
    components: {
        DataPostViewPage,
    },
    data() {
        return {
            data: null,
            modalCheck: false,
            modalNumber: null,
            hasLoaded: false,
        };
    },
    mounted() {
        this.hasLoaded = false;
        this.loadData();
    },
    watch: {
        $route(to, from) {
            if (to.params.id !== from.params.id) {
                this.hasLoaded = false;
                this.data = null;
                this.loadData();
            }
        },
    },
    methods: {
        getListQuery() {
            const query = { ...this.$route.query };
            delete query.password;
            delete query.pwd;
            return query;
        },
        async loadData() {
            const hasLegacyPassword =
                Object.prototype.hasOwnProperty.call(this.$route.query, 'password') ||
                Object.prototype.hasOwnProperty.call(this.$route.query, 'pwd');
            const legacyPassword = this.$route.query.password || this.$route.query.pwd || '';
            const password = legacyPassword || getDownloadPassword(this.$route.params.id);

            if (legacyPassword) {
                setDownloadPassword(this.$route.params.id, legacyPassword);
            }

            const result = await getDownloadDetail(this.$route.params.id, password, this.getListQuery());
            if (!result || !result.data || result.data.err) {
                removeDownloadPassword(this.$route.params.id);
                if (!this.hasLoaded) {
                    this.$router.replace({
                        path: `/cs/data`,
                        query: this.getListQuery(),
                    });
                }
                return;
            }

            this.data = result.data;
            this.hasLoaded = true;

            if (hasLegacyPassword) {
                this.$router.replace({
                    path: this.$route.path,
                    query: this.getListQuery(),
                });
            }
        },
        modalOpen: function (idx) {
            this.modalCheck = !this.modalCheck;
            if (this.modalCheck) {
                this.$refs.pwd.focus();
                this.$lenis.stop();
            } else {
                this.$lenis.start();
            }

            if (idx) this.modalNumber = idx;
        },
        checkPwd: async function (idx, pwd) {
            const result = await checkDownloadDetail({ idx, ...this.getListQuery(), password: pwd });
            if (result.err) {
                alert(result.err.response?.data || '비밀번호를 확인해주세요.');
                this.$refs.pwd.value = '';
                this.$refs.pwd.focus();
                return;
            }

            setDownloadPassword(idx, pwd);
            this.$refs.pwd.value = '';
            this.modalOpen();
            this.$router.replace({
                path: `/cs/data/${idx}`,
                query: this.getListQuery(),
            });
        },
    },
};
</script>
